export default __webpack_public_path__ + "static/media/d3.fb8d9b33.png";